/** @format */

import { z } from "zod";

export const userProfileSchema = z
  .object({
    fullName: z.string().min(1, "Required"),
    shortName: z.string().min(1, "Required"),
    email1: z.string().min(1, "Required").email("Invalid email address"),
    email2: z.string().min(1, "Required").email("Invalid email address"),
    favoriteDrivers: z.array(z.string()),
  })
  .refine(data => data.email1 === data.email2, {
    message: "Emails must match",
    path: ["email2"],
  });

export type UserProfileFormData = z.infer<typeof userProfileSchema>;
